<template>
  <div class="ymxk-business-container">
    <div class="bg-left"></div>
    <div class="bg-right"></div>
    <div class="ymxk-business-box">
      <div class="ymxk-business-content">
        <div class="ymxk-business-title">
          <span class="ymxk-business-title-left"></span>
          <span class="ymxk-business-title-middle">企业荣誉</span>
          <span class="ymxk-business-title-right"></span>
        </div>
        <div class="ymxk-business-img">
          <div class="ymxk-business-img-list" v-for="(item, index) in businessList" :key="index">
            <div class="bussion-sc">
              <img :src="item.img" alt="" />
            </div>
            <p class="ymxk-business-text" v-html="item.name"></p>
          </div>
        </div>
        <div class="yxmk-business-more" v-if="!honner">
          <span class="yxmk-business-more-click" @click="awards">更多奖项</span>
          <img src="~@/assets/img/ymxk-more.png" alt="" @click="awards" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { defineProps, onMounted, ref } from 'vue';
const { anchor, page } = defineProps({
  page: {
    type: String,
    default: '0'
  },
  anchor: {
    type: Boolean,
    default: false
  }
});
//企业荣誉
const businessList = ref([
  {
    name: '热烈祝贺盈美信科荣获<br>第十八届北青财星榜“金牌金融科技创新奖”',
    img: require('@/assets/img/07_rongyu.png')
  },
  {
    name: '热烈庆贺银盈通支付获得<br>美国联邦MSB(货币服务业务)金融牌照',
    img: require('@/assets/img/08_rongyu.png')
  },
  {
    name: '热烈庆祝北京国美融通科技有限公司<br>再度通过“高新技术企业”认定',
    img: require('@/assets/img/09_rongyu.png')
  },
  {
    name: '热烈庆祝盈美信科荣获<br>2025年互联网及金融反诈联盟"优秀先锋成员奖"',
    img: require('@/assets/img/10_rongyu.png')
  }, {
    name: '热烈庆祝盈美信科荣获<br>北京青年报第十八届(2025)财星榜<br>[金牌金融科技创新榜单]',
    img: require('@/assets/img/11_rongyu.jpg')
  },
  {
    name: '热烈庆祝盈美信科荣获<br>2024天津商业保理创新发展基地裕业奖',
    img: require('@/assets/img/01_rongyu.png')
  },
  {
    name: '执烈庆祝博盛安融(天津)融资担保有限公司接入中国人民银行个人征信系统',
    img: require('@/assets/img/02_rongyu.jpg')
  },
  {
    name: '国美融通科技有限公司荣获北京市“专精特新”中小企业认定',
    img: require('@/assets/img/03_rongyu.jpg')
  },
  {
    name: '热烈庆祝国美金融APP荣获国家计算机病毒应急处理中心APP安全与APP信息安全检测最高等级认证',
    img: require('@/assets/img/04_rongyu.jpg')
  },
  {
    name: '国美小贷荣获2023年度非银行类金融机构征信系统数据质量工作优秀机构',
    img: require('@/assets/img/05_rongyu.jpg')
  },
  {
    name: '热烈庆祝盈美信科荣获2023天津商业保理创新发展基地裕业奖',
    img: require('@/assets/img/06_rongyu.jpg')
  }
]);
//更多奖项
const router = useRouter();

const awards = () => {
  router.push({
    path: '/about'
  });
};
const honner = localStorage.getItem('honner');

onMounted(() => {
  if (anchor) {
    window.scrollTo({
      top: document.querySelector('.ymxk-business-container').getBoundingClientRect().top
    });
  }
  if (page === 'home') {
    businessList.value = businessList.value.slice(0, 6);
  }
});
</script>
<style lang="scss" scoped>
.ymxk-business-container {
  background: linear-gradient(136deg,
      rgba(131, 203, 255, 0.03) 0%,
      rgba(35, 163, 255, 0.03) 100%);
  position: relative;

  .bg-left {
    background-image: url('../assets/img/bg/honer-left.png');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 1240px;
    height: 856px;
    position: absolute;
    left: 0;
    top: 0;
  }

  .bg-right {
    background-image: url('../assets/img/bg/honer-right.png');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 1240px;
    height: 856px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .ymxk-business-box {
    position: relative;
    width: 100%;
    height: 100%;

    .ymxk-business-content {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      padding: 60px 0 50px;

      .ymxk-business-title {
        margin-bottom: 49px;

        .ymxk-business-title-left {
          width: 8px;
          height: 8px;
          background: #23a1ff;
          opacity: 0.3;
          display: inline-block;
          vertical-align: top;
        }

        .ymxk-business-title-middle {
          width: 120px;
          height: 30px;
          font-size: 30px;
          font-weight: bold !important;
          color: #000000;
          line-height: 30px;
          margin: 0 10px;
        }

        .ymxk-business-title-right {
          width: 8px;
          height: 8px;
          background: #23a1ff;
          opacity: 0.3;
          display: inline-block;
        }
      }

      .ymxk-business-img {
        text-align: left;

        .ymxk-business-img-list {
          width: 370px;
          display: inline-table;
          margin-right: 45px;
          margin-bottom: 40px;
          font-size: 0; //解决img标签与p标签之间的默认间隔
          text-align: center;

          .bussion-sc {
            width: 370px;
            height: 214px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              transition: all 0.5s;
            }

            img:hover {
              transform: scale(1.1);
            }
          }

          .ymxk-business-text {
            background: #f5f8ff;
            height: 66px;
            font-size: 14px;
            color: #000000;
            line-height: 24px;
            padding: 9px 21px;
          }
        }

        .ymxk-business-img-list:nth-of-type(3n) {
          margin-right: 0;
        }
      }

      .yxmk-business-more {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;

        .yxmk-business-more-click {
          font-size: 16px;
          color: #23a0ff;
          line-height: 16px;
          margin-right: 5px;
          cursor: pointer;
        }

        img {
          width: 8px;
          height: 8px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
